export default __webpack_public_path__ + "static/media/rupturearmor.34a4db34.png";